import { render, staticRenderFns } from "./NewChatDialogBody.vue?vue&type=template&id=794c02e9&scoped=true&"
import script from "./NewChatDialogBody.vue?vue&type=script&lang=js&"
export * from "./NewChatDialogBody.vue?vue&type=script&lang=js&"
import style0 from "./NewChatDialogBody.vue?vue&type=style&index=0&id=794c02e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c02e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
